import { render, staticRenderFns } from "./EmployeeVacationForecastWidget.vue?vue&type=template&id=05ee5b1a&scoped=true&"
import script from "./EmployeeVacationForecastWidget.vue?vue&type=script&lang=js&"
export * from "./EmployeeVacationForecastWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ee5b1a",
  null
  
)

export default component.exports